import React from 'react';

// Voice activation disabled - moved to backlog
// Local Whisper-based speech recognition was implemented but needs further tuning
// Features built:
// - Transformers.js with Whisper tiny model (runs 100% locally, no audio sent anywhere)
// - Silence detection (stops recording when user finishes speaking)
// - Wake word detection ("Hey" + command)
// - Model caching in browser IndexedDB
//
// To re-enable: restore the full component code from git history

const VoiceActivation = ({ onCommand, isEnabled = true }) => {
  return null;
};

export default VoiceActivation;
